<template>
  <div></div>
</template>

<script>
import { mapMutations } from 'vuex'
import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin'

export default {
  name: 'SiteBookingSettingSet',
  mixins: [SiteBookingSettingMixin],
  watch: {
    siteBookingSettingStackGroupBooking: {
      immediate: true,
      handler (value) {
        this.setStackGroupBooking(value)
      }
    }
  },
  methods: {
    ...mapMutations('BookingUpload', [
      'setStackGroupBooking'
    ])
  }
}
</script>
